import { UserRecent } from '../hooks/recents';
import { type Doc, DocItem } from './docs';
import { IDriveContent } from './drive';

export type AIRole = 'user' | 'assistant';

export type MessagesHistoryType = {
  role: AIRole;
  content: string;
};

export type AiChat = {
  _id: string;
  owner: string;
  workspace: string;
  messages: AiChatMessage[];
  createdAt: string;
  title: string;
  updatedAt: string;
};

export type AIResponseStateType = AIResponse & {
  isLoadingSources?: boolean;
  isLoadingThinking?: boolean;
  isReasoningCollapsed?: boolean;
};

export type AIResponse = {
  query: string;
  searchSources: SearchSource[];
  reasoning: string;
  content: string;
  status: 'loading' | 'thinking' | null;
  searchTime?: number;
  reasoningTime?: AITiming;
  error?: string | null;
};

export interface SearchSource {
  sourceType: 'url';
  id: string;
  url: string;
  title: string;
}

export type AIContextFile = {
  id: string;
  type: 'doc' | 'image' | 'file';
};

export interface AITiming {
  start?: string;
  end?: string;
}

export type AiChatMessage = AIResponse & {
  _id: string;
  workspace: string;
  user: string;
  chat: string;
  contextFiles?: AIContextFile[];
  role: AIRole;
  createdAt: string;

  // Temporary Data
  doSearch?: boolean;
  think?: boolean;
  error?: string;
};

export enum AiPromptTemplate {
  OPEN_ASK = 'open_ask',
  SUMMARIZE = 'summarize',

  // NOTES PROMPT
  SUMMARIZE_TRANSCRIPTION = 'summarize_transcription',
  FIND_ACTIONS_ITEMS = 'find_actions_items',
  BRAINSTORM_IDEAS = 'brainstorm_ideas',
  TO_DO_LIST = 'to_do_list',
  MEETING_AGENDA = 'meeting_agenda',
  PROS_AND_CONS_LIST = 'pros_and_cons_list',

  // DOCS PROMPT
  CONTINUE_WRITING = 'continue_writing',
  IMPROVE_WRITING = 'improve_writing',
  EXTRACT_IDEAS = 'extract_ideas',
  TRANSLATE = 'translate',
  IMPROVE_GRAMMAR = 'improve_grammar',
  TRANSCRIPTION_AI_ACTION_OWN_PROMPT = 'transcription_ai_action_own_prompt',
}

export enum ContextItemType {
  FILE = 'file',
  RECENT = 'recent',
  DRIVE = 'drive',
  DOC = 'doc',
  IMAGE = 'image',
}

export type ContextItemFileType =
  | ContextItemMediaType
  | UserRecent
  | IDriveContent
  | DocItem
  | Doc;

export type ContextItemMediaType = {
  _id: string;
  media: File;
};
export type ContextItems = {
  type: ContextItemType;
  file?: ContextItemMediaType;
  image?: ContextItemMediaType;
  recent?: UserRecent;
  drive?: IDriveContent;
  doc?: DocItem | Doc;
};
